@if (rubricLevels(); as rubricLevels) {
	<nz-table #rubricLevelTable [nzData]="rubricLevels" [nzLoading]="loading()" [nzNoResult]="noData">
		<thead>
			<tr>
				<th>Rubric Code</th>
				<th>Level</th>
				<th>Name</th>
				<th>Short Description</th>
				<th>Created</th>
				<th>Updated</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			@for (level of rubricLevels; track level) {
				<tr [class.selected]="level.uuid === rubricService.selectedRubricLevelBs$.value?.uuid">
					<td>{{ level.rubric_code }}</td>
					<td>{{ level.level }}</td>
					<td>{{ level.name }}</td>
					<td>{{ level.short_description }}</td>
					<td>{{ level.created | date: 'medium' }}</td>
					<td>{{ level.updated | date: 'medium' }}</td>
					<td>
						@if (level.uuid === rubricService.selectedRubricLevelBs$.value?.uuid) {
							<button nz-button (click)="selectRubricLevel(undefined)">Clear</button>
						}
						@if (level.uuid !== rubricService.selectedRubricLevelBs$.value?.uuid) {
							<span>&nbsp;</span>
							<button nz-button nzType="primary" (click)="selectRubricLevel(level)">Edit</button>
						}
						<span>&nbsp;</span>
						<button
							nz-button
							nzDanger
							nz-popconfirm
							nzPopconfirmTitle="Are you sure delete this?"
							nzPopconfirmPlacement="bottom"
							(nzOnConfirm)="deleteRubricLevel(level.uuid)"
						>
							Delete
						</button>
					</td>
				</tr>
			}
		</tbody>
		<ng-template #noData>
			<nz-typography>No rubric levels available</nz-typography>
		</ng-template>
	</nz-table>
}
